import React, { FC } from "react";
import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  link: {
    overflowWrap: "break-word",
    textDecoration: "none",
    "&:hover": {
      color: theme.palette.primary.dark,
      cursor: "pointer",
    },
  },
  nolink: {
    overflowWrap: "break-word",
    textDecoration: "none",
  },
}));

type HyperlinkProps = {
  url?: string;
  noLink?: boolean;
};

const Hyperlink: FC<HyperlinkProps> = ({ url, children, noLink }): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      {noLink ? (
        <span className={classes.nolink}>{children}</span>
      ) : (
        <a rel="noopener noreferrer" target="_blank" href={url} className={classes.link}>
          {children}
        </a>
      )}
    </>
  );
};

export default Hyperlink;
